import { motion } from "framer-motion";

export default function StatCard({ icon: Icon, label, value, sub, tone = "emerald", accent = false, delay = 0, testId }) {
  const tones = {
    emerald: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300",
    amber: "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300",
    blue: "bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300",
    rose: "bg-rose-100 text-rose-600 dark:bg-rose-900/40 dark:text-rose-300",
    teal: "bg-teal-100 text-teal-700 dark:bg-teal-900/40 dark:text-teal-300",
  };

  if (accent) {
    return (
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay }}
        whileHover={{ y: -4 }} data-testid={testId}
        className="relative overflow-hidden rounded-2xl p-5 text-white shadow-md"
        style={{ background: "linear-gradient(135deg, #173404 0%, #275C0A 55%, #408310 100%)" }}>
        <div className="absolute -top-10 -right-8 h-32 w-32 rounded-full bg-lime-300/20 blur-2xl" />
        <div className="relative z-10 flex items-start justify-between gap-3">
          <div className="min-w-0">
            <p className="text-xs font-semibold uppercase tracking-wider text-lime-100/90">{label}</p>
            <p className={`mt-2 font-extrabold tracking-tight ${typeof value === "string" && value.length > 6 ? "text-base text-lime-100/80 italic" : "text-3xl"}`}>{value}</p>
            {sub && <p className="mt-1 text-xs text-lime-50/80">{sub}</p>}
          </div>
          <div className="h-11 w-11 shrink-0 rounded-xl bg-white/15 flex items-center justify-center"><Icon className="h-5 w-5 text-lime-200" /></div>
        </div>
      </motion.div>
    );
  }

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay }}
      whileHover={{ y: -4 }} data-testid={testId}
      className="glass glass-hover rounded-2xl p-5">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-xs font-semibold uppercase tracking-wider text-emerald-700 dark:text-emerald-300">{label}</p>
          <p className={`mt-2 font-extrabold text-emerald-950 dark:text-emerald-50 tracking-tight ${typeof value === "string" && value.length > 6 ? "text-base text-slate-400 italic" : "text-3xl"}`}>{value}</p>
          {sub && <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">{sub}</p>}
        </div>
        <div className={`h-11 w-11 shrink-0 rounded-xl flex items-center justify-center ${tones[tone]}`}>
          <Icon className="h-5 w-5" />
        </div>
      </div>
    </motion.div>
  );
}
